(function () {
  'use strict';
  if (window.rmShopifyCart && window.rmShopifyCart.__ready) return;

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart = null;
  var busy = false;
  var discountCode = '';

  function request(path, options) {
    return fetch(rootPath + path, options || {}).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error((body && (body.description || body.message)) || 'Shopify cart request failed.');
        return body;
      });
    });
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || (cart && cart.currency) || 'USD',
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function cleanDiscountCode(value) {
    return String(value || '').trim().replace(/\s+/g, '');
  }

  function checkoutPath() {
    var checkout = rootPath + 'checkout';
    if (!discountCode) return checkout;
    return rootPath + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(checkout);
  }

  function tray() { return document.querySelector('[data-rm-cart-tray]'); }

  function setOpen(open) {
    var node = tray();
    if (!node) return;
    node.dataset.open = open ? 'true' : 'false';
    node.setAttribute('aria-hidden', open ? 'false' : 'true');
    node.inert = !open;
    document.body.classList.toggle('rm-cart-open', open);
    document.querySelectorAll('[data-rm-cart-open]').forEach(function (button) { button.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    var scrim = document.querySelector('[data-rm-cart-scrim]');
    if (scrim) scrim.hidden = !open;
    if (open) document.dispatchEvent(new CustomEvent('rm:cart-open'));
  }

  function updateCount() {
    var count = cart ? Number(cart.item_count || 0) : 0;
    document.querySelectorAll('[data-rm-cart-count]').forEach(function (node) { node.textContent = String(count); });
    document.querySelectorAll('.rm-mobile-cart[data-rm-cart-open]').forEach(function (button) {
      button.setAttribute('aria-label', 'Open cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function setError(text) {
    var node = document.querySelector('[data-rm-cart-error]');
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
  }

  function render() {
    var list = document.querySelector('[data-rm-cart-lines]');
    var empty = document.querySelector('[data-rm-cart-empty]');
    var fields = document.querySelector('[data-rm-cart-fields]');
    var subtotal = document.querySelector('[data-rm-cart-subtotal]');
    var note = document.querySelector('[data-rm-cart-note]');
    var checkout = document.querySelector('[data-rm-cart-checkout]');
    var discountInput = document.querySelector('[data-rm-cart-discount-code]');
    var discountMessage = document.querySelector('[data-rm-cart-discount-message]');
    var discountNote = document.querySelector('[data-rm-cart-discount-note]');
    if (!list) return;
    list.innerHTML = '';
    var items = (cart && cart.items) || [];
    if (empty) empty.hidden = items.length > 0;
    if (fields) fields.hidden = items.length === 0;
    if (subtotal) subtotal.textContent = money(cart ? cart.total_price : 0, cart && cart.currency);
    if (note && document.activeElement !== note) note.value = (cart && cart.note) || '';
    if (discountInput && document.activeElement !== discountInput) discountInput.value = discountCode;
    if (discountMessage) {
      discountMessage.hidden = !discountCode;
      discountMessage.textContent = discountCode ? 'Offer will be calculated at checkout.' : '';
    }
    if (discountNote) discountNote.hidden = !discountCode;
    if (checkout) {
      checkout.href = checkoutPath();
      checkout.setAttribute('aria-disabled', items.length ? 'false' : 'true');
    }
    updateCount();

    items.forEach(function (item) {
      var row = document.createElement('li');
      row.className = 'rm-cart-line';
      row.setAttribute('data-rm-line-key', item.key);
      var title = item.product_title || item.title || 'Item';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      row.innerHTML =
        (item.image ? '<img class="rm-cart-line__image" src="' + escapeHtml(item.image) + '" alt="" width="56" height="56">' : '<span class="rm-cart-line__image"></span>') +
        '<div class="rm-cart-line__body"><p class="rm-cart-line__title">' + escapeHtml(title) + (variantTitle ? '<br><span>' + escapeHtml(variantTitle) + '</span>' : '') + '</p>' +
        '<div class="rm-cart-line__controls"><button type="button" data-rm-qty-down aria-label="Decrease quantity">−</button><span data-rm-line-qty>' + Number(item.quantity || 0) + '</span><button type="button" data-rm-qty-up aria-label="Increase quantity">+</button><button type="button" data-rm-line-remove aria-label="Remove item">⌫</button></div></div>' +
        '<strong class="rm-cart-line__price">' + money(item.final_line_price, cart && cart.currency) + '</strong>';
      list.appendChild(row);
    });
    setError('');
  }

  function refresh() {
    return request('cart.js').then(function (nextCart) {
      cart = nextCart;
      render();
      return cart;
    });
  }

  function addItems(items) {
    if (busy) return Promise.reject(new Error('The cart is busy.'));
    if (!items || !items.length) return Promise.reject(new Error('No items selected.'));
    busy = true;
    setOpen(true);
    setError('');
    return request('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(refresh).catch(function (error) {
      setError(error.message || 'Could not add to cart.');
      throw error;
    }).finally(function () { busy = false; });
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    request('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    }).then(function (nextCart) {
      cart = nextCart;
      render();
    }).catch(function (error) { setError(error.message || 'Could not update cart.'); })
      .finally(function () { busy = false; });
  }

  function saveNote(value) {
    return request('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: value || '' }),
    }).then(function (nextCart) { cart = nextCart; render(); });
  }

  function bind() {
    document.querySelectorAll('[data-rm-cart-open]').forEach(function (button) {
      if (button.dataset.rmCartBound === 'true') return;
      button.dataset.rmCartBound = 'true';
      button.addEventListener('click', function () { setOpen(!(tray() && tray().dataset.open === 'true')); if (!cart) refresh(); });
    });
    var node = tray();
    if (node && node.dataset.rmCartBound !== 'true') {
      node.dataset.rmCartBound = 'true';
      node.addEventListener('click', function (event) {
        var target = event.target.closest('button, a');
        if (!target) return;
        if (target.matches('[data-rm-cart-close]')) { setOpen(false); return; }
        var row = target.closest('[data-rm-line-key]');
        if (!row) return;
        var key = row.getAttribute('data-rm-line-key');
        var quantity = Number((row.querySelector('[data-rm-line-qty]') || {}).textContent || 0);
        if (target.matches('[data-rm-qty-up]')) changeLine(key, quantity + 1);
        if (target.matches('[data-rm-qty-down]')) changeLine(key, quantity - 1);
        if (target.matches('[data-rm-line-remove]')) changeLine(key, 0);
      });
      var note = node.querySelector('[data-rm-cart-note]');
      if (note) note.addEventListener('change', function () { saveNote(note.value).catch(function (error) { setError(error.message); }); });
      var discountForm = node.querySelector('[data-rm-cart-discount-form]');
      if (discountForm) {
        discountForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var input = discountForm.querySelector('[data-rm-cart-discount-code]');
          discountCode = cleanDiscountCode(input && input.value);
          render();
        });
      }
    }
    var scrim = document.querySelector('[data-rm-cart-scrim]');
    if (scrim && scrim.dataset.rmCartBound !== 'true') {
      scrim.dataset.rmCartBound = 'true';
      scrim.addEventListener('click', function () { setOpen(false); });
    }
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') setOpen(false); });
    refresh().catch(function () { updateCount(); });
  }

  window.rmShopifyCart = {
    __ready: true,
    addItems: addItems,
    open: function () { setOpen(true); return refresh(); },
    close: function () { setOpen(false); },
    refresh: refresh,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
